import { Stack } from "@fluentui/react";
import { useAppContext } from "./AppContext";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";

export default function Reports() {

    const {appData, setAppData} = useAppContext(); // <-- get context method
    const navigate = useNavigate();

      useEffect(() => {
        // Set up interval to repeat every 5 seconds if scanning array is not empty
        let intervalId: NodeJS.Timeout | null = null;
        
        if (appData.scanning.length === 0) {
            navigate('/Reports');
        }
      }, [appData.scanning.length]);

    return ( 

        <Stack style={{ height: '100%', margin: '0 auto' }}>
            <Stack>
                <span>Now analyzing</span>
                <br/> 
                { 
                    appData.scanning.filter(item => item.status === "Analyzing").map( (item, index) =>
                        <img src={item.image} alt={`Receipt ${index}`} key={index}/>    
                    )
                }
            </Stack>
                <br/> 
            <Stack>  
                <span>Queued</span>
                <br/> 
                { 
                    appData.scanning.filter(item => item.status === "false").map( (item, index) =>
                        <img src={item.image} alt={`Receipt ${index}`} key={index}/> 
                    )
                }
                <br/>   
            </Stack>
        </Stack>
    )
}